import {
  logNormalDataSet,
  normalDataSet,
  triangularDataSet,
  truncatedLogNormalDataSet,
  truncatedNormalDataSet,
  uniformDataSet,
} from '@/modules/lcca/lib/calculations/probabilityDistributionChart';

import { IDistribution } from '@/lib/monteCarlo/interfaces';

// @ts-ignore
import * as jstat from 'jstat';

export const getPdfFromDistribution = function (dist: IDistribution) {
  // console.debug("Setting PDF data");

  const min = dist.min || 0;
  const mean = dist.mean || 0;
  const mode = dist.mode || 0;
  const max = dist.max || 0;
  const std = dist.std || 0;
  const location = dist.location || 0;
  const shape = dist.shape || 0;


  let data: {x:number, y:number}[] = [];

  switch (dist.prob) {
    case 'deterministic':
      data = [
        { x: mean, y: 0 },
        { x: mean, y: 1 },
      ];
      break;
    case 'uniform':
      data = uniformDataSet(min, max);
      break;
    case 'normal':
      data = normalDataSet(mean, std);
      break;
    case 'lognormal':
      data = logNormalDataSet(location, shape);
      // console.log(`The probabilistic model is Log Normal with mean: ${mean} and standard deviation: ${std}`);
      // console.log(data);
      break;
    case 'triangular':
      data = triangularDataSet(min, max, mode);
      break;
    case 'truncatednormal':
      data = truncatedNormalDataSet(mean, std, min, max);
      break;
    case 'truncatedlognormal':
      data = truncatedLogNormalDataSet(location, shape, min, max);
      break;
    default:
      throw Error('Distribution not found');
  }

  // const x = data.map((xy) => xy.x);
  // const y = data.map((xy) => xy.y);

  const ret = data.map((xy) => [xy.x, xy.y]);

  return ret;
};

export const sampleDistribution = (distParams: IDistribution): number => {
  let val;
  switch (distParams.prob) {
    case 'normal':
      return jstat.normal.sample(distParams.mean, distParams.std);
    case 'truncatednormal':
      val = jstat.normal.sample(distParams.mean, distParams.std);
      if (distParams.min && val < distParams.min) {
        val = distParams.min;
      }
      if (distParams.max && val > distParams.max) {
        val = distParams.max;
      }
      return val;
    case 'truncatedlognormal':
      val = jstat.lognormal.sample(distParams.location, distParams.shape);
      if (distParams.min && val < distParams.min) {
        val = distParams.min;
      }
      if (distParams.max && val > distParams.max) {
        val = distParams.max;
      }
      return val;
    case 'triangular':
      return jstat.normal.sample(distParams.min, distParams.mode, distParams.max);
    case 'uniform':
      return jstat.uniform.sample(distParams.min, distParams.max);
    case 'lognormal':
      return jstat.lognormal.sample(distParams.location, distParams.shape);
    case 'deterministic':
      return distParams.mean || NaN;
    default:
      return NaN;
  }
};
